import { Col, Form, Row } from 'react-bootstrap';
import TextInput from 'src/Components/GenericInputText/TextInput';

const UnlockAttempts = ({ values, setFieldValue, errors, touched }) => {
  return (
    <Row className="open-enrollment-approval Payment-details section-separator-border">
      <Col md={5} lg={5} sm={5} className="padding-0">
        <h3>Unlock Attempt(s)</h3>
        <p>Configure maximum number of sign in attempt allowed.</p>
      </Col>
      <Col md={5} lg={5} sm={5}>
        <div className="retroactive-days-label">Max Failed Unlock Attempts</div>
        <Row className="pt-2">
          <Col>
            <TextInput
              inputProps={{
                name: 'MaxUnlockAttempts',
                isInvalid: false,
                placeholder: 'Enter Number of Days',
                value: values.MaxUnlockAttempts,
                onChange: (e) => {
                  setFieldValue('MaxUnlockAttempts', e.target.value);
                },
              }}
            />
            <Form.Control.Feedback
              type="invalid"
              aria-live="polite"
              id="err_title"
              role="alert"
              className="d-block"
            >
              <span>
                {touched.MaxUnlockAttempts && errors.MaxUnlockAttempts}
              </span>
            </Form.Control.Feedback>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default UnlockAttempts;
